import { newstContractTemplate } from "views/create-contract/constants"

export const SIZES = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
}

export const CONTROL_SIZES = {
    [SIZES.XS]: 7,
    [SIZES.SM]: 9,
    [SIZES.MD]: 11,
    [SIZES.LG]: 14,
}

export const LAYOUT = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
    INLINE: 'inline',
}

export const DIRECTIONS = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left',
}

export const SELECTION_MODES = {
    YEAR: 'year',
    MONTH: 'month',
    DAY: 'day',
}

export const PICKER_VIEWS = {
    YEAR: 'year',
    MONTH: 'month',
    DATE: 'date',
}

export const STATUS = {
    DANGER: 'danger',
    SUCCESS: 'success',
    WARNING: 'warning',
}

export const STEPS_STATUS = {
    COMPLETE: 'complete',
    PENDING: 'pending',
    IN_PROGRESS: 'in-progress',
    ERROR: 'error',
}

export const PLACEMENT = {
    TOP_START: 'top-start',
    TOP_CENTER: 'top-center',
    TOP_END: 'top-end',
    BOTTOM_START: 'bottom-start',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_END: 'bottom-end',
    MIDDLE_START_TOP: 'middle-start-top',
    MIDDLE_START_BOTTOM: 'middle-start-bottom',
    MIDDLE_END_TOP: 'middle-end-top',
    MIDDLE_END_BOTTOM: 'middle-end-bottom',
}

export const DROPDOWN_ITEM_TYPE = {
    DEFAULT: 'default',
    HEADER: 'header',
    DIVIDER: 'divider',
    CUSTOM: 'custom',
}

export const DAY_DURATION = 86400000

// 一次繳清 月繳 季繳 半年繳 年繳 客製化
export const PAY_CHANNEL_METHODS = [
    {
        value: 'pay_all_at_once',
        label: '一次繳清',
    },
    {
        value: 'pay_by_per_month',
        label: '月繳',
    },
    {
        value: 'pay_by_quarterly',
        label: '季繳',
    },
    {
        value: 'pay_by_half_year',
        label: '半年繳',
    },
    {
        value: 'pay_by_per_year',
        label: '年繳',
    },
    {
        value: 'pay_by_custom',
        label: '客製化',
    },
]

export const PAY_CHANNEL = {
    0: {
        label: '虛擬帳號',
        fee: 17,
    },
    1: {
        label: '超商代收',
        fee: 35,
    },
    9900: {
        label: '現金繳費',
        fee: 0,
    },
    9901: {
        label: '國泰虛擬帳號',
        fee: 0,
    },
    9902: {
        label: '國泰超商代收',
        fee: 0,
    },
    9904: {
        label: '凱基虛擬帳號',
        fee: 0,
    },
    9903: {
        label: '自訂轉帳',
        fee: 0,
    },
}

export const TEMPLATE_TYPE_OPTIONS = [
    {
        type: 'personal_government_normal_house',
        name: '內政部住宅租賃契約書',
    },
    {
        type: 'personal_house',
        name: '房屋租賃契約書',
    },
    {
        type: 'personal_parking_space',
        name: '車位租賃契約書',
    },
    {
        type: 'personal_office',
        name: '辦公室租賃契約書',
    },
    {
        type: 'personal_office_only_address',
        name: '設址租賃契約書',
    },
    {
        type: 'personal_government_rental_subleasing_house',
        name: '包租業住宅租賃契約書',
    },
    {
        type: newstContractTemplate.personalTraditionalPaper,
        name: '紙本合約',
    },
    {
        type: newstContractTemplate.juridicalPersonTraditionalPaper,
        name: '紙本合約',
    }
]

export const AFFORDABLE_HOUSE_MATCH_TYPE = {
    0: '包租包管',
    1: '代租代管',
}

export const AFFORDABLE_HOUSE_MATCH_STATUS = {
    'servicing': '服務中',
    'close': '已結案',
}

export const AFFORDABLE_HOUSE_MATCH_CONTRACT_VERSION = {
    'v3.1': '增辦第三期',
    'v4': '第四期',
    'v4.1': '增辦第四期',
}
